import { useI18n } from "@baton/i18n";
import { SkeletonBlock, SkeletonRegion } from "@baton/ui";
import { PANEL_MIN_WIDTH, useAssistantPanel } from "./store.ts";
import "./dockFallback.css";

/**
 * What stands in the dock while its chunk loads (`contracts/design-system.md` § Loading): the panel's
 * frame at its width with the head's line, a said block and three answer lines in the thread's own
 * geometry, so the dock neither flashes empty nor jumps when the panel lands. It is the shell's, not the
 * chunk's, and so carries its own small stylesheet.
 */
export function DockFallback({ narrow = false }: { readonly narrow?: boolean }) {
  const { t } = useI18n();
  const width = useAssistantPanel((state) => state.width);
  return (
    <aside role="complementary" aria-label={t("nav.assistant")} data-slot="side-peek" className="b-dock-fallback" style={{ inlineSize: `${narrow ? PANEL_MIN_WIDTH : width}px` }}>
      <SkeletonRegion className="b-dock-fallback__body">
        <SkeletonBlock className="b-dock-fallback__head" />
        <SkeletonBlock className="b-dock-fallback__said" />
        <SkeletonBlock className="b-dock-fallback__line" />
        <SkeletonBlock className="b-dock-fallback__line" />
        <SkeletonBlock className="b-dock-fallback__line b-dock-fallback__line--short" />
      </SkeletonRegion>
    </aside>
  );
}
